<template>
  <el-dialog
        title="详情"
        :visible.sync="centerDialogVisible"
        width="50%"
        top="15vh"
        :before-close="close"
        center>
        <el-form ref="ruleForm"  label-width="120px">
            <el-form-item label="标题">
                {{obj.title}}
            </el-form-item>
            <el-form-item label="图片" prop="img" v-if="obj.img || obj.imgs">
              <div v-if="obj.imgs" class="upload-demo avatar-uploader">
                <img v-for="img in obj.imgs" :src="img" class="avatar" :key="img">
              </div>
              <div class="upload-demo avatar-uploader" v-else>
                <img v-if="obj.img" :src="obj.img" class="avatar">
              </div>
            </el-form-item>
            <el-form-item label="区域" prop="location" v-if="obj.location">
              {{ obj.location }}
            </el-form-item>
            <el-form-item label="要求" v-if="obj.tags">
              {{ obj.tags }}
            </el-form-item>
            <el-form-item label="服务区域" v-if="obj.localtion">
              {{ obj.localtion }}
            </el-form-item>
            <el-form-item label="描述" prop="fee" v-if="obj.description">
                <pre style="margin:0;white-space: pre-wrap;">{{ obj.description }}</pre>
            </el-form-item>
            <el-form-item label="发布人">
                {{ obj.public }}
            </el-form-item>
            <el-form-item label="联系方式">
                {{ obj.mobile }}
            </el-form-item>
            <el-form-item label="地址" prop="address" v-if="obj.address">
              {{ obj.address }}
            </el-form-item>
            <el-form-item label="薪资/价格" prop="fee" v-if="obj.fee">
                {{ obj.fee }}
            </el-form-item>
            <el-form-item label="新车报价" prop="fee" v-if="obj.yuanjia">
                {{ obj.yuanjia }}
            </el-form-item>
            <el-form-item label="现价" prop="fee" v-if="obj.xianjia">
                {{ obj.xianjia }}
            </el-form-item>
            
            
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="$emit('close')">关 闭</el-button>
        </span>
  </el-dialog>
</template>
<script>
  export default {
    props: {
      centerDialogVisible: true,
      obj: Object
    },
    data() {
      return {
      }
    },
    methods: {
      close() {
        this.$emit('close')
      }
    }
  }
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .upload-demo {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }
  .avatar {
    width: 178px;
    height: auto!important;
    display: block;
    object-fit: contain!important;
    margin-right: 10px;
  }
</style>
